import React from 'react';

type IconProps = {
  className?: string
}

export const PlayIcon = ({ className }: IconProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_244_1738"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_244_1738)">
        <path
          d="M16.417 33.7497V13.958C16.417 13.4066 16.6074 12.9494 16.9882 12.5863C17.3694 12.223 17.8185 12.0413 18.3357 12.0413C18.4713 12.0413 18.6298 12.0622 18.8112 12.1038C18.9928 12.1455 19.1792 12.207 19.3703 12.2884L34.917 22.2913C35.2225 22.458 35.4517 22.6849 35.6045 22.9722C35.7573 23.2594 35.8337 23.5602 35.8337 23.8747C35.8337 24.1891 35.7538 24.4899 35.5941 24.7772C35.4344 25.0644 35.2087 25.2774 34.917 25.4163L19.3703 35.4192C19.1792 35.5284 18.9895 35.5969 18.8012 35.6247C18.6128 35.6524 18.452 35.6663 18.3187 35.6663C17.8089 35.6663 17.3645 35.4948 16.9853 35.1517C16.6064 34.8087 16.417 34.3413 16.417 33.7497Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
